import {useEffect, useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";

import {useMe} from "@/src/modules/core/hooks";

import {handlePushNotificationClick} from "../lib/handle-push-notification-click";
import {pushNotificationDataFromSearchParams} from "../lib/mark-notification-read-from-push";

/**
 * Cold start from OS notification: SW opens `/#/path?_push=1&...` before /me is ready.
 * Runs once after me loads for mark-read and compliance side effects (does not change property).
 */
export function usePushNotificationDeepLink() {
  const location = useLocation();
  const navigate = useNavigate();
  const {data: me} = useMe();
  const consumedRef = useRef(false);

  useEffect(() => {
    if (!me || consumedRef.current) {
      return;
    }

    const pushData = pushNotificationDataFromSearchParams(
      new URLSearchParams(location.search),
    );
    if (!pushData) {
      return;
    }

    consumedRef.current = true;
    handlePushNotificationClick(pushData, navigate, `${location.pathname}${location.search}`);
  }, [location.pathname, location.search, me, navigate]);
}
